export const scrollToElement = (elementId, options = { behavior: 'smooth' }) => {
    var _a;
    (_a = document.getElementById(elementId)) === null || _a === void 0 ? void 0 : _a.scrollIntoView(options);
};
